import React from "react";
import { useSelector } from "react-redux";
import { DNA } from "react-loader-spinner";

// Overlay de chargement GLOBAL : visible dès qu'une requête réseau est en cours
// (compteur redux ui.pending). z-index sous SaveLoader (9999). 100% frontend.
const GlobalLoader = () => {
  const pending = useSelector((s) => (s.ui ? s.ui.pending : 0));
  if (!pending) return null;
  return (
    <div style={{
      position: "fixed", inset: 0,
      background: "rgba(255,255,255,0.72)",
      backdropFilter: "blur(2px)",
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      zIndex: 9998, gap: "12px"
    }}>
      <DNA visible={true} height="96" width="96" ariaLabel="chargement" wrapperClass="dna-wrapper" />
      <p style={{ fontSize: "1rem", color: "#475569", fontWeight: 500 }}>Chargement…</p>
    </div>
  );
};

export default GlobalLoader;
